import { CommonModule, formatDate } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { CardModule } from 'primeng/card';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TagModule } from 'primeng/tag';
import { TableModule } from 'primeng/table';
import { ProgressBarModule } from 'primeng/progressbar';
import { DashboardService } from '../../../pages/service/dashboard.service';
import { SelectButtonModule } from 'primeng/selectbutton';
import { InMemoryStorageService } from '../../../services/in-memory-storage.service';
import { environment } from '../../../../environments/environment';
import { Calendar } from 'primeng/calendar';
import { FormsModule } from '@angular/forms';
@Component({
    selector: 'app-sales-person-ranking',
    templateUrl: './sales-person-ranking.component.html',
    styleUrls: ['./sales-person-ranking.component.scss'],
    imports: [ProgressBarModule, TableModule, FormsModule, CommonModule, CardModule, TagModule, ProgressSpinnerModule, SelectButtonModule, Calendar]
})
export class SalesPersonRankingComponent implements OnInit {
    @Input() rankingData: any[] = [];
    loading = false;

    // Date filter controls
    dateViewOptions = [
        { label: 'This Month', value: 'month' },
        { label: 'This Year', value: 'year' },
        { label: 'Custom', value: 'custom' }
    ];
    selectedView: string = 'month';
    fromDate: string = '';
    toDate: string = '';

    constructor(
        private dashboardService: DashboardService,
        private inMemoryStorage: InMemoryStorageService
    ) {}

    ngOnInit() {
        this.setDefaultDates();
        this.loadRankingData();
    }

    /** Sets the date range based on selected view */
    onDateViewChange() {
        this.setDefaultDates();
        if (this.selectedView !== 'custom') this.loadRankingData();
    }

    /** Sets default from/to date depending on selectedView */
    private setDefaultDates() {
        const today = new Date();
        if (this.selectedView === 'month') {
            const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
            const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0); // last day of the current month

            this.fromDate = formatDate(startOfMonth, 'yyyy-MM-dd', 'en');
            this.toDate = formatDate(endOfMonth, 'yyyy-MM-dd', 'en');
        } else if (this.selectedView === 'year') {
            const startOfYear = new Date(today.getFullYear(), 0, 1);
            const endOfYear = new Date(today.getFullYear(), 11, 31); // 31st December

            this.fromDate = formatDate(startOfYear, 'yyyy-MM-dd', 'en');
            this.toDate = formatDate(endOfYear, 'yyyy-MM-dd', 'en');
        }
    }

    /** Trigger when custom dates are selected */
    onDateChange() {
        if (!this.isValidDateString(this.fromDate)) this.fromDate = '';
        if (!this.isValidDateString(this.toDate)) this.toDate = '';
        if (this.fromDate && this.toDate && this.toDate < this.fromDate) this.toDate = '';
        this.loadRankingData();
    }
    private isValidDateString(dateStr: string): boolean {
        return /^\d{4}-\d{2}-\d{2}$/.test(dateStr);
    }

    /** Fetch ranking data with date filters */
    loadRankingData() {
        this.loading = true;

        const fromDateParam = formatDate(this.fromDate, 'yyyy-MM-dd', 'en'); // "2025-10-01"
        const toDateParam = formatDate(this.toDate, 'yyyy-MM-dd', 'en'); // "2025-10-31"
        const company = this.inMemoryStorage.get('company');
        const division = this.inMemoryStorage.get('division');
        const apiUrl = `${environment.apiUrl}dashboard/UsersRanking?company=${encodeURIComponent(company)}&division=${encodeURIComponent(division)}&fromDate=${fromDateParam}&toDate=${toDateParam}&reportPeriod=NOPERIOD`;

        this.dashboardService.getSalesRanking(apiUrl).subscribe({
            next: (data) => {
                const arr = Array.isArray(data) ? data : (data as any)?.content || [];
                console.log(arr);

                this.rankingData = arr.sort((a: any, b: any) => this.getProgress(b) - this.getProgress(a));
                console.log(this.rankingData);

                this.loading = false;
            },
            error: () => {
                this.rankingData = [];
                this.loading = false;
            }
        });
    }

    // ===== Utility Methods =====
    getProgress(person: any): number {
        if (!person?.target) return 0;
        const achievement =
            person.achievement != null
                ? Number(person.achievement)
                : Number(person.orderLineAmount || 0);
        const progress = (achievement / person.target) * 100;
        return isNaN(progress) ? 0 : +progress.toFixed(2);
    }

    getProgressClass(progress: number): string {
        if (progress < 45) return 'progress-red';
        if (progress >= 45 && progress <= 79) return 'progress-yellow';
        return 'progress-green';
    }

    getStatusIcon(progress: number): string {
        if (progress < 45) return 'pi-times-circle';
        if (progress >= 45 && progress <= 79) return 'pi-exclamation-triangle';
        return 'pi-check-circle';
    }

    getStatusText(progress: number): string {
        if (progress < 45) return 'Below Target';
        if (progress >= 45 && progress < 80) return 'Approaching Target';
        if (progress >= 80 && progress < 100) return 'Near to Target';
        if (progress > 100) return 'Exceeding Target';
        return 'Target Achieved';
    }

    getRankClass(index: number): string {
        if (index === 0) return 'rank-1';
        if (index === 1) return 'rank-2';
        if (index === 2) return 'rank-3';
        return 'rank-default';
    }
}
